import CollapsePanel from '../collapse/panel.vue'

/* istanbul ignore next */
CollapsePanel.install = function (Vue) {
  Vue.component(CollapsePanel.name, CollapsePanel)
}

export default CollapsePanel
